import { createStyles, makeStyles } from "@mui/styles";
import { CommonFonts, Colors } from "@/theme";
import { dialogClasses } from "@mui/material/Dialog";

const useStyles = makeStyles((theme) =>
  createStyles({
    container: {
      [`& .${dialogClasses.paper}`]: {
        borderRadius: 32,
        maxWidth: "90vw",
      },
    },
    title: {
      textAlign: "center",
      "&.MuiDialogTitle-root": {
        ...CommonFonts.darkBoldFont28,
        padding: "20px 24px 10px 24px",
      },
    },
    content: {
      "&.MuiDialogContent-root": {
        padding: 0,
      },
    },
    storeNameText: {
      ...CommonFonts.darkBoldFont20,
      color: Colors.DIM_GREY,
    },
    labelText: {
      ...CommonFonts.darkFont14,
      color: Colors.DIM_GREY,
    },
    addressText: {
      ...CommonFonts.darkFont18,
      color: Colors.DIM_GREY,
    },
    codeText: {
      ...CommonFonts.darkBoldFont28,
    },
    priceText: {
      ...CommonFonts.darkBoldFont18,
    },
    input: {
      width: "100%",
      backgroundColor: Colors.WHITE,
      "& .MuiInputBase-root": {
        paddingRight: 0,
      },
      "& input": {
        height: 60,
        fontSize: 22,
        padding: "0px 10px",
        color: Colors.GRAY_DARK,
        textAlign: "center",
        fontWeight: "bold",
      },
      "& fieldset": {
        borderWidth: 1,
        borderColor: Colors.GRAY_BORDER,
        borderRadius: 10,
      },
      "& .MuiInputBase-root:hover fieldset": {
        borderColor: Colors.GRAY_BORDER,
      },
      "& .MuiInputBase-root.Mui-focused fieldset": {
        borderColor: Colors.BLUE,
        borderWidth: 1,
      },
    },
    currencyInput: {
      width: "100%",
      ...CommonFonts.darkBoldFont22,
      textAlign: "center",
      fontFamily: "Montserrat",
      height: 60,
      padding: 0,
      border: `1px solid ${Colors.GRAY_BORDER}`,
      borderRadius: 10,
      transition: "border-color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
      outline: "none",
      "&:hover": {
        border: `1px solid ${Colors.GRAY_BORDER}`,
      },
      "&:focus": {
        border: `1px solid ${Colors.BLUE}`,
        transition: "border-color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        PointerEvent: "none",
      },
      "&:focus:hover": {
        border: `1px solid ${Colors.BLUE}`,
        transition: "border-color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        PointerEvent: "none",
      },
    },
    updateButton: {
      width: 220,
      height: 60,
    },
  })
);

export default useStyles;
